import tour15Gif from '../../../assets/images/tour-images/tour-15.gif';
import tour16Gif from '../../../assets/images/tour-images/tour-16.gif';
import tour17Gif from '../../../assets/images/tour-images/tour-17.gif';
import tour19Gif from '../../../assets/images/tour-images/tour-19.gif';

export const tourText = {
  createCourseButton: {
    title: 'Start a course',
    description:
      'Create impactful courses tailored to your goals to inspire learning and empower your audience.',
    image: tour15Gif,
    link: {
      label: 'Watch how to create a course',
      url: 'https://www.youtube.com/watch?v=A4yiZ9i1eBg',
    },
  },
  courseCardContainer: {
    title: 'Your courses',
    description: 'View and manage all the courses you’ve created.',
    image: tour16Gif,
  },
  courseCardInfoRightBox: {
    title: 'Quick status',
    description:
      'You can easily see if a course is public, has learners assigned, or requires approval or viewing only.',
    image: tour17Gif,
  },
  courseKebab: {
    title: 'Course actions',
    description:
      'Open this menu on any course card to edit the course, manage learners, view the syllabus, copy, or delete it.',
    image: tour19Gif,
  },
};
